import React, { useState } from 'react';
import RoyaltyCard from './RoyaltyCard';
import { TOTAL_PACKAGES } from '../../config/contracts';

// Royalty is available for packages 1..TOTAL_PACKAGES-1 (package 12 has no next tier)
const RoyaltyList = ({ userId }) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const bump = () => setRefreshKey((k) => k + 1);

  const pkgs = [];
  for (let i = 1; i < TOTAL_PACKAGES; i++) pkgs.push(i);

  return (
    <div className="grid grid-auto">
      {pkgs.map((p) => (
        <RoyaltyCard
          key={p}
          pkgId={p}
          userId={userId}
          refreshKey={refreshKey}
          onClaimed={bump}
        />
      ))}
    </div>
  );
};

export default RoyaltyList;
